import React, { Suspense } from "react";

import { SpinnerFullScreen } from "../../../../components/SpinnerFullScreen";
import AdminPSAUsers from "./AdminPSAUsers";

// const AdminPSARoute = React.lazy(() => import("./AdminPSAUsers"));

export const AdminPSARouteWithLazy: React.FC = () => {
  return (
    <Suspense fallback={<SpinnerFullScreen />}>
      <AdminPSAUsers />
    </Suspense>
  );
};
